import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    results: null,
});

class Store extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.LIST_AMOUNT_BY_SLOT_FINISH:
                return state.set('results', action.result);

            default:
                return state;
        }
    }
}

export default new Store();



// WEBPACK FOOTER //
// src/stores/DistribuicaoVendasStore.js